var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBodysamiranegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    preserveAspectRatio: "xMidYMax",
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "body_samira_negative_svg__a",
    d: "M.544 102.985C.544 46.577 46.265.85 102.686.85h113.355c56.412 0 102.143 45.731 102.143 102.136v102.136H.544V102.985z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_samira_negative_svg__e",
    d: "M0 128.202C0 57.398 57.403 0 128.204 0c70.805 0 128.204 57.404 128.204 128.202v44.897c0 70.804-57.4 128.202-128.204 128.202C57.399 301.3 0 243.897 0 173.099v-44.897z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_samira_negative_svg__g",
    d: "M0 17.1C0 7.656 7.652 0 17.107 0h53.97c9.448 0 17.107 7.649 17.107 17.1v17.555c0 19.14-15.512 34.655-34.663 34.655H34.663C15.519 69.31 0 53.8 0 34.655V17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_samira_negative_svg__i",
    d: "M0 17.1C0 7.656 7.652 0 17.107 0h53.97c9.448 0 17.107 7.649 17.107 17.1v17.555c0 19.14-15.512 34.655-34.663 34.655H34.663C15.519 69.31 0 53.8 0 34.655V17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_samira_negative_svg__k",
    d: "M31.611 6.779c28.53 16.6 83.51 67.47 174.594 10.9 50.355-48.805 21.825 21.646 21.825 21.646s39.861 29.665 28.95 46.017c-10.913 16.35-98.21 38.153-141.858 38.153C71.473 123.495.047 92.609.047 85.342c0-7.268 27.778-41.787 27.778-41.787l14.55 3.712s-66.74-30.38-10.764-40.488z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_samira_negative_svg__c",
    width: 50.827,
    height: 68.098,
    x: 0.476,
    y: 0.461,
    rx: 25.414
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(31.64 32.125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6E574A",
    stroke: "#363A4F",
    strokeWidth: 14.766,
    d: "M175.165-7.383c50.43-.008 96.086 20.43 129.132 53.479 33.04 33.041 53.476 78.688 53.476 129.107h0V359.8c0 5.825-2.36 11.098-6.177 14.914a21.026 21.026 0 01-14.914 6.178h0H13.709a21.027 21.027 0 01-14.915-6.177A21.023 21.023 0 01-7.383 359.8h0V175.203c0-49.873 19.996-95.075 52.407-128.028C77.498 14.16 122.435-6.56 172.21-7.359h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M319.83 225.895l-17.128 45.421s8.06 20.763 2.015 36.337c-6.045 15.574 42.315 73.684 42.315 73.684l-66.496-12.112s-24.18-56.959-24.18-51.478c0 5.48 5.038-55.515 5.038-55.515l58.435-36.337zM61.955 82.753s-101.14 130.752 7.08 270.627l38.433-60.815L76.115 84.78l-14.16-2.028z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.823 29.367)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 326.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_samira_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_samira_negative_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F15165",
    stroke: "#363A50",
    strokeWidth: 24.469,
    xlinkHref: "#body_samira_negative_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15165",
    stroke: "#363A50",
    strokeWidth: 11.813,
    d: "M.544 102.985C.544 46.577 46.265.85 102.686.85h113.355c56.412 0 102.143 45.731 102.143 102.136v102.136H.544V102.985z",
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "-23.888 197.828 342.616 314.519 377.031 108.8 -2.279 85.097",
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#79BEAA",
    points: "-23.888 97.546 342.616 214.237 377.031 8.518 -2.279 -15.185",
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7084B1",
    points: "-11.354 28.496 355.15 145.187 313.212 -6.147 3.234 -24.379",
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "33.249 201.674 38.719 97.746 46.012 199.715",
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "279.408 201.674 284.878 97.746 292.172 199.715",
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.02,
    x2: 37.729,
    y1: 25.59,
    y2: 100.345,
    stroke: "#000",
    strokeLinecap: "round",
    strokeOpacity: 0.1,
    strokeWidth: 1.055,
    mask: "url(#body_samira_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.711,
    x2: 247.42,
    y1: 26.502,
    y2: 101.257,
    stroke: "#000",
    strokeLinecap: "round",
    strokeOpacity: 0.1,
    strokeWidth: 1.055,
    mask: "url(#body_samira_negative_svg__b)",
    transform: "matrix(-1 0 0 1 533.131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M52.66 29.135S-8.202 75.723 18.21 232.705l-30.324-18.269-1.013-176.226L13.217 23.02l22.29-7.09L52.66 29.135z",
    mask: "url(#body_samira_negative_svg__b)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.362,
    cy: 174.291,
    fill: "#E9B79E",
    stroke: "#363A50",
    strokeWidth: 9.492,
    rx: 32.524,
    ry: 32.554
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.673,
    cy: 181.554,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 14.185,
    ry: 14.179
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.181,
    cy: 172.468,
    fill: "#E9B79E",
    stroke: "#363A50",
    strokeWidth: 9.492,
    rx: 32.524,
    ry: 32.554
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.32,
    cy: 175.68,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 14.185,
    ry: 14.179
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.843 276.23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_samira_negative_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_samira_negative_svg__c"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 65.593,
    height: 82.864,
    x: -6.907,
    y: -6.922,
    stroke: "#363A50",
    strokeWidth: 14.766,
    rx: 32.796
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.091,
    height: 105.966,
    x: -14.112,
    y: -26.889,
    fill: "#F9CCB6",
    mask: "url(#body_samira_negative_svg__d)",
    rx: 39.545
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M8.32 12.617S-2.622 47.26 25.641 65.493c28.262 18.233-5.47 17.321-5.47 17.321l-37.38-30.996-.912-33.731 26.44-5.47z",
    mask: "url(#body_samira_negative_svg__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.884 .385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_samira_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_samira_negative_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#body_samira_negative_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9B79E",
    stroke: "#363A50",
    strokeWidth: 14.766,
    d: "M128.233 7.383c33.352.008 63.545 13.53 85.403 35.388 21.865 21.864 35.389 52.07 35.389 85.43h0V173.1c0 33.502-13.582 64.777-35.476 88.283-21.78 23.384-51.814 39.108-85.027 41.61-33.49-2.5-63.66-18.191-85.519-41.542-22.011-23.513-35.62-54.817-35.62-88.351h0v-44.897c0-33.001 13.232-62.912 34.68-84.717C63.54 21.65 93.257 7.941 126.174 7.4h0z",
    mask: "url(#body_samira_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M10.574 160.455S23.745 95.636 28.81 95.636c5.066 0 24.316 30.384 205.676 55.704 0 0-5.126 79.067-25.411 107.425 27.378-17.724 49.727-66.957 49.727-66.957l8.105-61.78-61.804-33.422L75.417 55.08H6.521L-12.73 119.9l23.303 40.555z",
    mask: "url(#body_samira_negative_svg__f)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M240.327 150.935c-6.349-10.991-23.86-12.765-39.114-3.962M74.53 143.586c6.348-10.992 23.86-12.766 39.114-3.962"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6.202,
    d: "M140.723 207.266s7.612 17 17.001 17c9.39 0 17.001-17 17.001-17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7.031,
    d: "M206.073 168.627c0-5.539 4.286-10.028 9.573-10.028h0c5.287 0 9.573 4.49 9.573 10.028M91.141 168.627c0-5.539 4.286-10.028 9.573-10.028h0c5.287 0 9.573 4.49 9.573 10.028"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.168,
    d: "M21.596 169.052c5.442-3.268 12.5-1.513 15.766 3.92h0c3.266 5.433 1.502 12.487-3.94 15.755M278.25 171.038c4.79-4.163 12.047-3.66 16.207 1.123h0c4.16 4.784 3.648 12.037-1.143 16.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7.235,
    d: "M129.353 246.145c4.926-6.197 15.293-10.726 30.65-10.726 15.358 0 24.64 4.193 28.85 10.726"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.536 124.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.428 20.668)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_samira_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_samira_negative_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    stroke: "#363A4F",
    strokeWidth: 9,
    d: "M71.077 4.5c3.482 0 6.635 1.41 8.917 3.69a12.555 12.555 0 013.69 8.91h0v17.555c0 8.328-3.375 15.867-8.833 21.325a30.071 30.071 0 01-21.33 8.83h0-18.858c-8.33 0-15.871-3.374-21.33-8.832C7.875 50.522 4.5 42.984 4.5 34.655h0V17.1c0-3.48 1.41-6.63 3.691-8.91a12.57 12.57 0 018.916-3.69h0z",
    mask: "url(#body_samira_negative_svg__h)",
    transform: "matrix(-1 0 0 1 88.184 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M9.012 60.422S64.802 29.817 84.6-18.79c19.796-48.608 8.998 99.015 8.998 99.015H18.011L9.012 60.422z",
    mask: "url(#body_samira_negative_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.747 20.668)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_samira_negative_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_samira_negative_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    stroke: "#363A4F",
    strokeWidth: 9,
    d: "M71.077 4.5c3.482 0 6.635 1.41 8.917 3.69a12.555 12.555 0 013.69 8.91h0v17.555c0 8.328-3.375 15.867-8.833 21.325a30.071 30.071 0 01-21.33 8.83h0-18.858c-8.33 0-15.871-3.374-21.33-8.832C7.875 50.522 4.5 42.984 4.5 34.655h0V17.1c0-3.48 1.41-6.63 3.691-8.91a12.57 12.57 0 018.916-3.69h0z",
    mask: "url(#body_samira_negative_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M8.998 89.033s55.79-30.605 75.587-79.212c19.796-48.607 8.998 99.015 8.998 99.015H17.997L8.998 89.033z",
    mask: "url(#body_samira_negative_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7.2,
    d: "M113.232 52.173s15.344 18.902 31.495-.9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.16,
    x2: 255.554,
    y1: 35.872,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 32.394,
    y1: 35.872,
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7.2,
    transform: "matrix(-1 0 0 1 32.394 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#6E574A",
    d: "M55.292 82.267s116.65 93.683 248.886 93.683c0 0 47.04-105.933-61.72-141.019C133.7-.155 55.293 82.267 55.293 82.267z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 12.656,
    d: "M305.767 173.725s-176.46-9.149-242.969-88.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M67.545 75.833s179.333-104.282 245.19 81.023C241.812-2.984 67.545 75.833 67.545 75.833z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.376 286.282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_samira_negative_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_samira_negative_svg__k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#7A695F",
    stroke: "#363A50",
    strokeWidth: 11.602,
    xlinkHref: "#body_samira_negative_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7084B1",
    stroke: "#363A50",
    strokeWidth: 11.602,
    d: "M31.611 6.779c28.53 16.6 83.51 67.47 174.594 10.9 50.355-48.805 21.825 21.646 21.825 21.646s39.861 29.665 28.95 46.017c-10.913 16.35-98.21 38.153-141.858 38.153C71.473 123.495.047 92.609.047 85.342c0-7.268 27.778-41.787 27.778-41.787l14.55 3.712s-66.74-30.38-10.764-40.488z",
    mask: "url(#body_samira_negative_svg__l)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "79.499 65.358 36.045 65.358 19.876 94.624 .675 82.514 29.981 40.128",
    mask: "url(#body_samira_negative_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M51.322 47.192S22.015 27.01 29.089 22.972c7.074-4.037 18.19-5.046 18.19-5.046L30.1 6.825 9.89 18.935 21.005 37.1l30.317 10.092zM204.927 21.963s20.211 13.119 6.063 24.22c-14.147 11.101-34.359 16.147-34.359 16.147s79.835-10.092 70.74 21.193c-9.095 31.285 7.074 3.028 7.074 3.028l5.052-15.138-26.274-28.257-3.032-16.147 7.074-22.203-5.053-6.055-27.285 23.212z",
    mask: "url(#body_samira_negative_svg__l)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 17.911,
    height: 17.893,
    x: 180.233,
    y: 380.219,
    fill: "#363A50",
    rx: 7.383
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C7C7C7",
    strokeLinecap: "round",
    strokeWidth: 9.492,
    d: "M189.801 388.047s11.162 9.59.08 30.167c-11.083 20.577-5.656 15.024-11.108 30.167-5.452 15.143-1.852 54.85-1.852 54.85"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.911,
    height: 17.893,
    x: 153.366,
    y: 371.272,
    fill: "#363A50",
    rx: 7.383
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DFDFDF",
    strokeLinecap: "round",
    strokeWidth: 9.492,
    d: "M163.868 380.219s-10.983 9.59-.078 30.167c10.904 20.576 23.782 15.024 29.146 30.167 5.365 15.143 1.822 54.85 1.822 54.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7.383,
    d: "M277.626 326.54s-47.159 25.721-67.168 25.721"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 11.602,
    d: "M90.676 332.132s31.21 17.893 45.898 17.893"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodysamiranegative);
export default __webpack_public_path__ + "static/media/body.samira.negative.5d25ace8.svg";
export { ForwardRef as ReactComponent };